import { FC } from 'react';
import { Modal } from 'antd';
import AddNutShape from './addNutShape';
import NutShapeList from './NutShapeList';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadNutShapes } from './NutShapeSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { AppState } from '../../redux/store/rootReducer';
const NutShapePage: FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen, setModelChange, contextHolder, setEditBodySize, editBodySize } = React.useContext(CommonContext) as CommonContextType;
  const NutShapes = useSelector(
    (state: AppState) => state.NutShapes
  );
  const showModal = () => {
    setModelChange(true);
  };
  const handleCancel = () => {
    setEditBodySize(null)
    setModelChange(false);
  };

  React.useEffect(() => {
    dispatch(loadNutShapes());
  }, [dispatch]);
  return (
    <div className='padding' style={{ background: '#ffffff' }}>
      {contextHolder}
      <br></br>
      <h2>Nut Shape List
        <button className='top-button' onClick={showModal}>Create</button>
      </h2>
      <br></br>
      <NutShapeList />
      <Modal title={editBodySize?.id ? 'Edit Nut Shape' : 'Create Nut Shape'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null}>
        <AddNutShape />
      </Modal>
    </div>
  );

};

export default NutShapePage;